export default __webpack_public_path__ + "static/media/ban-member.f8856b3d.svg";